module.exports = __webpack_public_path__ + "img/monitorPicture.fd68cb19.png";